import React, { useState } from 'react';
import { Modal, TextInput, PasswordInput, Button, Stack, Group, Text, Tabs, Anchor } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useAuth } from '../contexts/AuthContext';

const LoginModal = ({ opened, onClose }) => {
  const { login, register } = useAuth();
  const [loading, setLoading] = useState(false);

  const loginForm = useForm({
    initialValues: {
      email: '',
      password: '',
    },
    validate: {
      email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
      password: (value) => (value.length < 6 ? 'Password must be at least 6 characters' : null),
    },
  });

  const registerForm = useForm({
    initialValues: {
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
    },
    validate: {
      username: (value) => (value.length < 3 ? 'Username must be at least 3 characters' : null),
      email: (value) => (/^\S+@\S+$/.test(value) ? null : 'Invalid email'),
      password: (value) => (value.length < 6 ? 'Password must be at least 6 characters' : null),
      confirmPassword: (value, values) => (value !== values.password ? 'Passwords do not match' : null),
      firstName: (value) => (value.length < 2 ? 'First name must be at least 2 characters' : null),
      lastName: (value) => (value.length < 2 ? 'Last name must be at least 2 characters' : null),
    },
  });

  const handleLogin = async (values) => {
    setLoading(true);
    const result = await login(values.email, values.password);
    setLoading(false);
    if (result.success) {
      onClose();
    }
  };

  const handleRegister = async (values) => {
    setLoading(true);
    const { confirmPassword, ...userData } = values;
    const result = await register(userData);
    setLoading(false);
    if (result.success) {
      onClose();
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Welcome to WildernessFinder"
      size="md"
    >
      <Tabs defaultValue="login">
        <Tabs.List>
          <Tabs.Tab value="login">Login</Tabs.Tab>
          <Tabs.Tab value="register">Register</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="login" pt="md">
          <form onSubmit={loginForm.onSubmit(handleLogin)}>
            <Stack gap="md">
              <TextInput
                label="Email"
                placeholder="your.email@example.com"
                required
                {...loginForm.getInputProps('email')}
              />
              
              <PasswordInput
                label="Password"
                placeholder="Your password"
                required
                {...loginForm.getInputProps('password')}
              />
              
              <Button type="submit" loading={loading} color="green" fullWidth>
                Sign In
              </Button>
            </Stack>
          </form>
        </Tabs.Panel>

        <Tabs.Panel value="register" pt="md">
          <form onSubmit={registerForm.onSubmit(handleRegister)}>
            <Stack gap="md">
              <Group grow>
                <TextInput
                  label="First Name"
                  placeholder="John"
                  required
                  {...registerForm.getInputProps('firstName')}
                />
                <TextInput
                  label="Last Name"
                  placeholder="Doe"
                  required
                  {...registerForm.getInputProps('lastName')}
                />
              </Group>
              
              <TextInput
                label="Username"
                placeholder="johndoe"
                required
                {...registerForm.getInputProps('username')}
              />
              
              <TextInput
                label="Email"
                placeholder="your.email@example.com"
                required
                {...registerForm.getInputProps('email')}
              />
              
              <PasswordInput
                label="Password"
                placeholder="Your password"
                required
                {...registerForm.getInputProps('password')}
              />
              
              <PasswordInput
                label="Confirm Password"
                placeholder="Confirm your password"
                required
                {...registerForm.getInputProps('confirmPassword')}
              />
              
              <Button type="submit" loading={loading} color="green" fullWidth>
                Create Account
              </Button>
            </Stack>
          </form>
        </Tabs.Panel>
      </Tabs>
    </Modal>
  );
};

export default LoginModal;
